module.exports = __webpack_public_path__ + "img/scene-energy-hub.be555f3a.jpg";